<button mat-icon-button [matTooltip]="getNotificationTooltipText()" [matTooltipClass]="'pre-tooltip'" (click)="showNotificationPopup()">
    <mat-icon [style]="notification | notificationIconStyle">{{notification | notificationIcon}}</mat-icon>
</button>
